<y42-list-view
  name="Data tests"
  searchLabel="Search"
  [hideQuickFilters]="true"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [frameworkComponents]="frameworkComponents"
  (gridReady)="gridReady($event)"
  [hideSearch]="false"
  [canAdd]="true"
  [addPermissionAllowed]="state.addPermissionAllowed"
  (cellClicked)="onCellClick($event)"
  [messages]="messages"
>
  <ng-container y42ListViewAdditionalButtons>
    <y42-data-test-commit-button
      [filePath]="state.filePath"
      (commit)="commitClick()"
      [class]="'commit-button'"
    ></y42-data-test-commit-button>
  </ng-container>
</y42-list-view>
